import { render } from "./auth0.vue?vue&type=template&id=0629cec9&scoped=true"
import script from "./auth0.vue?vue&type=script&lang=js"
export * from "./auth0.vue?vue&type=script&lang=js"

import "./auth0.vue?vue&type=style&index=0&id=0629cec9&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\Dividenduitkering-Toets\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0629cec9"]])

export default __exports__